import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const handleDashboardClick = () => {
    window.REACT_APP_NAVIGATE('/dashboard');
  };

  const handleLoginClick = () => {
    window.REACT_APP_NAVIGATE('/login');
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center">
              <i className="ri-qr-code-line text-white text-xl"></i>
            </div>
            <span className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">LinkQR</span>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a href="#features" className={`text-sm font-medium transition-colors hover:text-teal-600 ${scrolled ? 'text-gray-700' : 'text-gray-900'}`}>
              {t('nav.features')}
            </a>
            <a href="#pricing" className={`text-sm font-medium transition-colors hover:text-teal-600 ${scrolled ? 'text-gray-700' : 'text-gray-900'}`}>
              {t('nav.pricing')}
            </a>
            
            <div className="flex items-center space-x-2 border-l pl-6">
              <button
                onClick={() => changeLanguage('en')}
                className={`px-3 py-1 text-xs font-medium rounded-md transition-colors whitespace-nowrap ${i18n.language === 'en' ? 'bg-teal-100 text-teal-700' : 'text-gray-600 hover:bg-gray-100'}`}
              >
                EN
              </button>
              <button
                onClick={() => changeLanguage('ko')}
                className={`px-3 py-1 text-xs font-medium rounded-md transition-colors whitespace-nowrap ${i18n.language === 'ko' ? 'bg-teal-100 text-teal-700' : 'text-gray-600 hover:bg-gray-100'}`}
              >
                한국어
              </button>
            </div>

            <button 
              onClick={handleDashboardClick}
              className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap"
            >
              {t('nav.dashboard')}
            </button>
            <button 
              onClick={handleLoginClick}
              className="px-5 py-2.5 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-sm font-semibold rounded-lg hover:shadow-lg hover:shadow-teal-500/30 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('nav.signup')}
            </button>
          </div>

          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t pt-4">
            <div className="flex flex-col space-y-4">
              <a href="#features" className="text-sm font-medium text-gray-700 hover:text-teal-600">
                {t('nav.features')}
              </a>
              <a href="#pricing" className="text-sm font-medium text-gray-700 hover:text-teal-600">
                {t('nav.pricing')}
              </a>
              <div className="flex items-center space-x-2 pt-2 border-t">
                <button
                  onClick={() => changeLanguage('en')}
                  className={`px-3 py-1 text-xs font-medium rounded-md transition-colors whitespace-nowrap ${i18n.language === 'en' ? 'bg-teal-100 text-teal-700' : 'text-gray-600 hover:bg-gray-100'}`}
                >
                  EN
                </button>
                <button
                  onClick={() => changeLanguage('ko')}
                  className={`px-3 py-1 text-xs font-medium rounded-md transition-colors whitespace-nowrap ${i18n.language === 'ko' ? 'bg-teal-100 text-teal-700' : 'text-gray-600 hover:bg-gray-100'}`}
                >
                  한국어
                </button>
              </div>
              <button 
                onClick={handleDashboardClick}
                className="text-sm font-medium text-gray-700 hover:text-teal-600 text-left"
              >
                {t('nav.dashboard')}
              </button>
              <button 
                onClick={handleLoginClick}
                className="px-5 py-2.5 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-sm font-semibold rounded-lg text-center whitespace-nowrap cursor-pointer"
              >
                {t('nav.signup')}
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
